

import RequestAbstract from "../abstract";

export default class WalletEvents extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallet/events";
    }
}
